/**
 * Performance Soil Slider
 */

document.addEventListener('DOMContentLoaded', () => {
  const sliderEl = document.querySelector('.js-performance-soil-slider');

  if (!sliderEl) return;

  const performanceSoilSlider = new Swiper('.js-performance-soil-slider', {
    slidesPerView: 'auto',
    spaceBetween: 24,
    freeMode: false,
    autoHeight: false,
    navigation: {
      nextEl: '.performance-soil .arrow-next',
      prevEl: '.performance-soil .arrow-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1.2,
        spaceBetween: 16,
        slidesOffsetAfter: 150,
      },
      768: {
        slidesPerView: 2.2,
        spaceBetween: 20,
        slidesOffsetAfter: 150,
      },
      1024: {
        slidesPerView: 'auto',
        spaceBetween: 24,
      }
    }
  });
});
